"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Guy = function Guy(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    height: "40",
    width: "40"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 7.477,3.334C9.119,5.038,11.384,6.001,13.751,6c1.186,0,2.36-0.242,3.449-0.711 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 17.25,6v5.25 c0,2.899-2.351,5.25-5.25,5.25s-5.25-2.351-5.25-5.25V6c0-2.899,2.351-5.25,5.25-5.25S17.25,3.101,17.25,6z ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 17.251,6.75 c0,1.522-1.215,4.683-2.25,5.25c-0.937,0.512-1.622-1.5-3-1.5S9.938,12.512,9,12c-1.035-0.567-2.25-3.728-2.25-5.25 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 21.635,23.25 c-0.563-3.605-3.09-6.595-6.55-7.752 ",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M 8.915,15.5c-3.46,1.157-5.987,4.147-6.55,7.752",
    stroke: fill,
    fill: "none",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
Guy.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Guy.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Guy;